module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/entities/maps/xml.json
 ** module id = 489
 ** module chunks = 0
 **/